function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isLinkToken, GridTokenMouseHandler } from '@deephaven/grid';
import deepEqual from 'fast-deep-equal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Handler also helps with other tooltips
class IrisGridTokenMouseHandler extends GridTokenMouseHandler {
  constructor(irisGrid) {
    super();
    _defineProperty(this, "irisGrid", void 0);
    _defineProperty(this, "lastColumn", void 0);
    _defineProperty(this, "lastRow", void 0);
    this.irisGrid = irisGrid;
    this.lastColumn = null;
    this.lastRow = null;
  }
  destroyTooltip() {
    this.irisGrid.setState({
      hoverTooltipProps: null
    });
  }
  setCursor(gridPoint, grid) {
    if (this.isHoveringLink(gridPoint, grid)) {
      this.cursor = 'pointer';
      return {
        stopPropagation: false,
        preventDefault: false
      };
    }
    this.cursor = null;
    return false;
  }
  onMove(gridPoint, grid) {
    var model = this.irisGrid.props.model;
    var isUserHoveringLink = this.isHoveringLink(gridPoint, grid);
    var modelColumn = this.irisGrid.getModelColumn(gridPoint.column);
    var modelRow = this.irisGrid.getModelRow(gridPoint.row);
    var tooltip = modelColumn != null && modelRow != null ? model.tooltipForCell(modelColumn, modelRow) : null;
    if (isUserHoveringLink && this.currentLinkBox != null && isLinkToken(this.currentLinkBox.token)) {
      var hoverTooltipProps = this.irisGrid.state.hoverTooltipProps;
      var _this$currentLinkBox = this.currentLinkBox,
        left = _this$currentLinkBox.x1,
        top = _this$currentLinkBox.y1,
        right = _this$currentLinkBox.x2,
        bottom = _this$currentLinkBox.y2;
      var href = this.currentLinkBox.token.href;
      var width = right - left;
      var height = bottom - top;
      var newProps = {
        left,
        top: top + 1,
        width,
        height
      };
      if (!deepEqual(hoverTooltipProps, newProps)) {
        this.irisGrid.setState({
          hoverTooltipProps: newProps,
          hoverDisplayValue: /*#__PURE__*/_jsxs(_Fragment, {
            children: [href, " - Click once to follow.", /*#__PURE__*/_jsx("br", {}), "Click and hold to select this cell."]
          })
        });
      }
    } else if (tooltip !== null) {
      var _hoverTooltipProps = this.irisGrid.state.hoverTooltipProps;
      var _newProps = {
        left: gridPoint.x,
        top: gridPoint.y + 1,
        width: 1,
        height: 1
      };
      if (!deepEqual(_hoverTooltipProps, _newProps)) {
        if (_hoverTooltipProps == null) {
          this.irisGrid.setState({
            hoverTooltipProps: _newProps,
            hoverDisplayValue: tooltip
          });
        } else if (this.lastColumn !== gridPoint.column || this.lastRow !== gridPoint.row) {
          this.irisGrid.setState({
            hoverTooltipProps: null
          }, () => this.irisGrid.setState({
            hoverTooltipProps: _newProps,
            hoverDisplayValue: tooltip
          }));
        }
      }
    } else {
      this.destroyTooltip();
    }
    this.lastColumn = gridPoint.column;
    this.lastRow = gridPoint.row;
    return this.setCursor(gridPoint, grid);
  }
  onDown() {
    this.destroyTooltip();
    return false;
  }
  onContextMenu() {
    this.destroyTooltip();
    return false;
  }
  onWheel() {
    this.destroyTooltip();
    return false;
  }
  onLeave() {
    this.destroyTooltip();
    return false;
  }
}
export default IrisGridTokenMouseHandler;
//# sourceMappingURL=IrisGridTokenMouseHandler.js.map